/* FYP · Pass 1 (5 Sep 2026 · s24, built on s23)
   Sticky add-to-cart bar, mobile info row: writes the short model name (the
   visible H1) and the selected variant into Impact's product-quick-add row,
   and keeps them current across variant changes and Impact's re-renders.
   Runs only below 700px; desktop keeps the July 2026 bar untouched.
   Revert: delete this file + its line in layout/theme.liquid. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  var MOBILE = window.matchMedia('(max-width: 699px)');

  function text(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function shortTitle() {
    var t = document.querySelector('.product-info .product-info__title .fyp-pdp-title__short') ||
            document.querySelector('.product-info .product-info__title');
    return text(t);
  }

  function variantLabel() {
    var out = [];
    document.querySelectorAll('.product-info .variant-picker__option-info').forEach(function (info) {
      var val = info.querySelector('legend + span') || info.querySelector('span');
      var v = text(val);
      if (v) out.push(v);
    });
    return out.join(' · ');
  }

  function apply() {
    if (!MOBILE.matches) return;
    var row = document.querySelector('product-quick-add .product-quick-add__variant');
    if (!row) return;
    var link = row.querySelector('a.bold');
    var st = shortTitle();
    if (link && st && link.getAttribute('data-fyp-short') !== st) {
      link.textContent = st;
      link.setAttribute('data-fyp-short', st);
    }
    var stack = row.querySelector('.v-stack');
    if (!stack) return;
    var v = variantLabel();
    var el = stack.querySelector('.fyp-qa__variant');
    if (v) {
      if (!el) { el = document.createElement('span'); el.className = 'fyp-qa__variant'; stack.appendChild(el); }
      if (el.textContent !== v) el.textContent = v;
    } else if (el) {
      el.remove();
    }
  }

  var timer = null;
  function schedule() { window.clearTimeout(timer); timer = window.setTimeout(apply, 60); }

  function boot() {
    if (!document.querySelector('product-quick-add')) return;
    apply();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-info, form[id^="product-form"]')) schedule();
    }, true);
    document.addEventListener('variant:change', schedule);
    var host = document.querySelector('product-rerender[id$="-sticky-bar"]') || document.body;
    new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
